import styles from './no-access-message.module.scss';
import { NoAccessMessageProps } from '../../interfaces/NoAccessMessageProps';

export function NoAccessMessage({ message }: NoAccessMessageProps) {
  return <div className={styles['no-access-message']}>{message}</div>;
}
